<form [formGroup]="corporateOwnersForm" class="space-y-6" (ngSubmit)="handleFormSubmission($event)">

    <!-- Responsive grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <!-- Country of Registration -->
        <div>
            <app-custom-dropdown label="CORPORATE_OWNERS_FORM.NATIONALITY"
                placeholder="CORPORATE_OWNERS_FORM.PLEASE_SELECT" [options]="countriesOptions" [isSearchable]="true"
                searchPlaceholder="{{'CORPORATE_OWNERS_FORM.SEARCH_COUNTRY' |translate}}"
                (optionSelected)="onDropdownSelect('nationality', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Empty for alignment -->
        <div class="sm:block hidden"></div>

        <div>
            <p class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
                {{'CORPORATE_OWNERS_FORM.OWNERS_NAME_AR' | translate}}
            </p>

            <div dir="rtl">
                <app-input-field label="اسم الشركة" placeholder="الرجاء الدخول" customClass="!mb-0" forceLang="ar"
                    [control]="getControl('corporateNameAr')">
                </app-input-field>
            </div>
        </div>

        <div>
            <p class="text-base font-medium mb-6 sm:col-span-2 text-(--text-muted)">
                {{'CORPORATE_OWNERS_FORM.OWNERS_NAME_EN' | translate}}
            </p>

            <div dir="ltr">
                <app-input-field label="Corporate name" placeholder="Please Enter" customClass="!mb-0" forceLang="en"
                    [control]="getControl('corporateNameEn')"></app-input-field>
            </div>
        </div>

    </div>

    <p class="text-base font-medium sm:col-span-2 text-(--text-muted)">
        {{'CORPORATE_OWNERS_FORM.OWNERSHIP_INFO' | translate}}
    </p>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <app-input-field label="{{ 'CORPORATE_OWNERS_FORM.CORPORATE_SHARE' | translate }}" type="number"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
            [control]="getControl('corporateShare')"></app-input-field>

        <app-date-picker label="CORPORATE_OWNERS_FORM.DATE_OF_ESTABLISHMENT" placeholder="DD/MM/YYYY"
            [control]="getControl('dateOfEstablishment')" [errorMessage]="'CORPORATE_OWNERS_FORM.INVALID_DATE'"
            modalTitle="CORPORATE_OWNERS_FORM.SELECT_DATE_OF_EST">
        </app-date-picker>
    </div>
    <!-- Submit Button -->
    <app-button text="{{ 'CORPORATE_OWNERS_FORM.CONFIRM_DETAILS' | translate }}" type="submit" variant="primary"
        size="lg" extraClass="mt-3 mb-12 w-full" [disabled]="corporateOwnersForm.invalid"></app-button>

</form>